"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOrderingAnswer = exports.isMcqAnswer = exports.isGapAnswer = exports.isEssayAnswer = void 0;
var isGapAnswer = function isGapAnswer(value) {
  return value !== undefined && value.type === 'gap';
};
exports.isGapAnswer = isGapAnswer;
var isEssayAnswer = function isEssayAnswer(value) {
  return value !== undefined && value.type === 'essay';
};
exports.isEssayAnswer = isEssayAnswer;
var isOrderingAnswer = function isOrderingAnswer(value) {
  return value !== undefined && value.type === 'ordering';
};
exports.isOrderingAnswer = isOrderingAnswer;
var isMcqAnswer = function isMcqAnswer(value) {
  return value !== undefined && value.type === 'mcq';
};
exports.isMcqAnswer = isMcqAnswer;